export enum Type {
  CANVA_AUTHORIZE_SUCCESS = 'app/canva/CANVA_AUTHORIZE_SUCCESS',
  CANVA_USER_CLEAR = 'app/canva/CANVA_USER_CLEAR',

  CREATE_CANVA_DESIGN_REQUEST = 'app/canva/CREATE_CANVA_DESIGN_REQUEST',
  CREATE_CANVA_DESIGN_SUCCESS = 'app/canva/CREATE_CANVA_DESIGN_SUCCESS',
  CREATE_CANVA_DESIGN_FAILURE = 'app/canva/CREATE_CANVA_DESIGN_FAILURE',

  CLEAR_CANVA_DESIGN_IN_PROGRESS = 'app/canva/CLEAR_CANVA_DESIGN_IN_PROGRESS',

  EXPORT_CANVA_DESIGN_REQUEST = 'app/canva/EXPORT_CANVA_DESIGN_REQUEST',
  EXPORT_CANVA_DESIGN_SUCCESS = 'app/canva/EXPORT_CANVA_DESIGN_SUCCESS',
  EXPORT_CANVA_DESIGN_FAILURE = 'app/canva/EXPORT_CANVA_DESIGN_FAILURE',
}
